
interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  option?: string;
  isSelected?: boolean;
  paymentMethodError?: boolean;
  
}

export function ButtonPago({
  option,
  children,
  className,
  onClick,
  isSelected,
  paymentMethodError,
  type = "button", // 👈 Aquí
  ...props
}: Props) {
  return (
    <button
      type={type}
      className={`${className} px-4 py-2 h-18 w-1/2 transition-colors items-center justify-center shadow-md shadow-blue-700 rounded-md duration-400 border 
      ${isSelected ? 'bg-blue-600 text-white shadow-none' : 'bg-zinc-600 text-white' } 
      ${paymentMethodError ? 'border-red-600' : 'hover:border-blue-700 active:bg-white active:text-black active:font-extrabold active:text-md'}`}
      onClick={(e) => {
        if (onClick) onClick(e);
      }}
      {...props}
    >
      {children}
    </button>
  );
}


export default ButtonPago;
